import React from "react";
import "./index.css";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const CustomCheckBox = (props) => {
  return (
    <div className="cstmChkBox">
      <FormControlLabel
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
        control={
          <Checkbox
            name={props.name}
            checked={props.checked}
            disabled={props.disabled}
            value={props.value}
            onChange={props.onChange}
            onClick={props.onClick}
            disableRipple
          />
        }
        label={props.label}
      />
    </div>
  );
};

export default CustomCheckBox;
